import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SmallMenuItem from './SmallMenuItem';

const SmallMenu = ({ onClick, showSidebar }) => (
  <>
    <MenuButton onClick={onClick} role="button" aria-label="Toggle menu">
      <FontAwesomeIcon icon="bars" color="#fff" size="1x" />
    </MenuButton>
    <CollapsibleMenu $showSidebar={showSidebar}>
      <SmallMenuItem url="/kontakt" text="Kontakt" />
      <SmallMenuItem url="/hundehold" text="Hundehold" />
      <SmallMenuItem url="/legestue" text="Legestue" />
      <SmallMenuItem url="/hyggedage" text="Søndagshygge" />
      <SmallMenuItem url="/hundetraening" text="Hund" />
      <SmallMenuItem url="/kattetraening" text="Kat" />
      <SmallMenuItem url="/onlinekurser" text="Onlinekurser" />
      <SmallMenuItem url="/prisoversigt" text="Priser" />
      <SmallMenuItem url="/foredrag" text="Foredrag" />
      <SmallMenuItem url="/snackshoppen" text="Butik" />
      <SmallMenuItem url="/dyreadfaerdskonsulent" text="Om Mig " />
      <SmallMenuItem url="/minemetoder" text="Mine metoder" />
    </CollapsibleMenu>
  </>
);

SmallMenu.propTypes = {
  onClick: PropTypes.func.isRequired,
  showSidebar: PropTypes.bool.isRequired,
};

export default SmallMenu;

const CollapsibleMenu = styled.div`
  height: ${(props) => (props.$showSidebar ? '395px' : '0')};
  width: 100%;
  overflow: hidden;
  transition: all 0.5s ease-out;
`;

const MenuButton = styled.button`
  background-color: #379683;
  padding: 0.625rem 0.75rem;
  border-radius: 3px;
  margin-bottom: 1rem;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  outline: none;
`;
